<ark-box size="small" class="options-menu--wrapper">
  <ng-container *ngFor="let item of options.items">
    <ark-options-menu-item
      [item]="item"
      *ngIf="item.visible"
      (itemClicked)="itemClick(item.identifier)"
    ></ark-options-menu-item>
  </ng-container>
</ark-box>
